// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** St. Vincent & Grenadines */
const VC: PhoneNumberData = [1, 'VC', 10, format0, /^(?:784)/];

export default VC;
